const SPEAK_TYPE = "ssml-speak";
const SPEAK_HTML_NODE_NAME = "div";

export { SPEAK_HTML_NODE_NAME, SPEAK_TYPE };
//# sourceMappingURL=constant.js.map
